// Mock data for AxisNet documentation site
export const libraryMenu = {
  title: "C# Library",
  basePath: "/docs/library",
  items: [
    { label: "Crud", path: "/docs/library/crud" },
    { label: "Common", path: "/docs/library/commons" },
    { label: "Domain", path: "/docs/library/domains" },
    { label: "Services", path: "/docs/library/services" },
    { label: "Behaviors", path: "/docs/library/behaviors" },
    { label: "Attribute", path: "/docs/library/attributes" },
    { label: "Extensions", path: "/docs/library/extensions" },
    { label: "Middleware", path: "/docs/library/middlewares" },
    { label: "Repository", path: "/docs/library/repositories" },
    { label: "Base Entity", path: "/docs/library/base-entities" },
    { label: "Presentation", path: "/docs/library/presentations" },
  ]
};

export const navigationItems = [
  {
    section: "Getting Started",
    items: [
      { title: "Introduction", path: "/docs/getting-started" },
    ]
  },
  {
    section: "Core Concepts",
    items: [
      {
        title: "C# Library",
        path: "/docs/library",
        children: [
          { title: "Crud", path: "/docs/library/crud" },
          { title: "Common", path: "/docs/library/commons" },
          { title: "Domain", path: "/docs/library/domains" },
          { title: "Services", path: "/docs/library/services" },
          { title: "Behaviors", path: "/docs/library/behaviors" },
          { title: "Attribute", path: "/docs/library/attributes" },
          { title: "Extensions", path: "/docs/library/extensions" },
          { title: "Middleware", path: "/docs/library/middlewares" },
          { title: "Repository", path: "/docs/library/repositories" },
          { title: "Base Entity", path: "/docs/library/base-entities" },
          { title: "Presentation", path: "/docs/library/presentations" },
        ]
      },
      {
        title: "CLI Tool", path: "/docs/cli",
        children: [
          { title: "Initialize", path: "/docs/cli" },
          { title: "Ready Project", path: "/docs/ready" },
          { title: "Add Domain", path: "/docs/cli/add-domain" },
          { title: "Add Feature", path: "/docs/cli/add-feature" },
          { title: "Add Service", path: "/docs/cli/add-service" },
          { title: "Add Controller", path: "/docs/cli/add-controller" },
          { title: "Add Repository", path: "/docs/cli/add-repository" },
          { title: "Add Test", path: "/docs/cli/add-test" },
          { title: "Info", path: "/docs/cli/info" },
          { title: "Help", path: "/docs/cli/help" },
          { title: "Flags", path: "/docs/cli/flags" },
        ]
      },
    ]
  }
];


export const features = [
  {
    title: "C# Library",
    description: "Enterprise-grade foundation with base classes, interfaces, and helpers for clean domain-driven design.",
    icon: "Package"
  },
  {
    title: "CLI Tool",
    description: "Scaffold features, domains, entities, and handlers instantly with powerful command-line interface.",
    icon: "Terminal"
  },
  {
    title: "Clean Architecture",
    description: "Enforce separation of concerns with Domain, Application, Infrastructure, and Presentation layers.",
    icon: "Layers"
  },
  {
    title: "Code Generation",
    description: "Generate CRUD operations, repositories, services, and more with a single command.",
    icon: "Code"
  }
];

export const cliCommands = [
  {
    command: "init",
    description:
      "Initializes the AxisNet project context by defining the Domain, Application, and Infrastructure layers.",
    example: "init"
  },
  {
    command: "init --file",
    description:
      "Loads the project configuration from the existing axisnet.json file instead of creating a new setup. This mode reads the Domain, Application, and Infrastructure layer paths from axisnet.json and initializes the CLI context based on the saved configuration.",
    example: "init --file"
  },
  {
    command: "add feature",
    description: "Generates a complete feature module.",
    example: "add feature --name Users"
  },
  {
    command: "add domain",
    description: "Generates a new Domain entity file using the predefined template.",
    example: "add domain --name Product"
  },
  {
    command: "add domain (with configuration)",
    description:
      "Generates a new Domain entity and also creates its Entity Framework Core configuration class. Ideal when defining custom field types, constraints, and relationship mappings.",
    example: "add domain --name Product --configuration"
  },
  {
    command: "add service",
    description:
      "Generates a new Service (Interface + Implementation) using the predefined AxisNet service template.",
    example: "add service --name Mail"
  },
  {
    command: "add controller",
    description: "Generates a new API controller.",
    example: "add controller --name Product"
  },
  {
    command: "add controller (versioned)",
    description: "Generates a controller with the specified API version.",
    example: "add controller --name Product --version 1.0"
  },
  {
    command: "add test",
    description: "Generates automated unit test boilerplates (Feature tests + Fake Repository).",
    example: "add test --name Product"
  },
  {
    command: "add repository",
    description: "Generates a new repository interface + implementation.",
    example: "add repository --name Product"
  },
  {
    command: "add repository (with domain)",
    description: "Adds domain entity generation as well.",
    example: "add repository --name Product --domain"
  },
  {
    command: "info",
    description: "Displays the current project context (paths, project name, and configuration).",
    example: "info"
  },
  {
    command: "help",
    description: "Displays a list of all available commands.",
    example: "help"
  },
  {
    command: "flags",
    description: "Displays all runtime flags and their current states.",
    example: "flags"
  },
  {
    command: "--version",
    description:
      "Displays the installed AxisNet CLI version. (Runs outside the AxisNet shell)",
    example: "axisnet --version"
  },
  {
    command: "exit",
    description: "Safely terminates the current AxisNet CLI session.",
    example: "exit"
  }
];



